/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AccountApiService } from './services/account-api.service';
import { GraphApiService } from './services/graph-api.service';
import { HealthCheckApiService } from './services/health-check-api.service';
import { LittleTiffApiService } from './services/little-tiff-api.service';
import { ParentApiService } from './services/parent-api.service';
import { StaffApiService } from './services/staff-api.service';
import { SupervisorApiService } from './services/supervisor-api.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AccountApiService,
    GraphApiService,
    HealthCheckApiService,
    LittleTiffApiService,
    ParentApiService,
    StaffApiService,
    SupervisorApiService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
